import {
  getFirestore,
  doc,
  getDoc,
  updateDoc,
  Timestamp,
} from "firebase/firestore";
import getUserUID from "../components/getUserUID";

const checkTrialExpiration = async () => {
  const db = getFirestore();
  const uid = await getUserUID();
  if (!uid) return;

  const userRef = doc(db, "registeredUsers", uid);
  const userSnap = await getDoc(userRef);

  if (!userSnap.exists()) return;

  const userData = userSnap.data();
  const { createdAt, subscriptionStatus } = userData;

  if (subscriptionStatus !== "trial" || !createdAt) return;

  const now = Timestamp.now().seconds;
  const created = createdAt.seconds;
  const daysSinceCreated = (now - created) / (60 * 60 * 24);

  if (daysSinceCreated > 30) {
    await updateDoc(userRef, { subscriptionStatus: "expired" });
  }
};

export default checkTrialExpiration;
